import { render, staticRenderFns } from "./AttachFormModal.vue?vue&type=template&id=0da79c84&"
import script from "./AttachFormModal.vue?vue&type=script&lang=js&"
export * from "./AttachFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports